module.exports = __webpack_public_path__ + "media/images/xpass/brand_previews/bft-3e34fba83c8efeac2249975a8a1af9d5.jpg";